// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3QBbX","list":"BalanceDue_list__3dKay","listRow":"BalanceDue_listRow__19Fhg","total":"BalanceDue_total__1X4TK"};